import { useIsMobile } from '@bbl-digital/snorre-v2'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import {
  extraLargeBreakpoint,
  navigationBreakpoint,
} from 'shared/constants/styles'
import { toggleMenu } from 'shared/store/menu'
import { getMenuStates } from 'shared/store/menu/selectors'

const NO_SIDEBAR = '0px'
const SIDEBAR_WIDTH_OPEN = '250px'
const SIDEBAR_WIDTH_CLOSED = '72px'

const useMenuLayout = () => {
  const { push } = useHistory()
  const dispatch = useDispatch()
  const isMobile = useIsMobile(navigationBreakpoint)
  const isSmallSceen = useIsMobile(extraLargeBreakpoint)
  const { open, isManuallyToggled } = useSelector(getMenuStates)

  const isOpen = open && (!isSmallSceen || isManuallyToggled)

  const goToHome = () => push('/')

  const handleOpen = (open: boolean) => {
    dispatch(toggleMenu(open))
  }

  const getSideMenyWidth = () => {
    if (isMobile) return NO_SIDEBAR
    if (isOpen) return SIDEBAR_WIDTH_OPEN
    return SIDEBAR_WIDTH_CLOSED
  }

  return {
    getSideMenyWidth,
    handleOpen,
    goToHome,
    isOpen,
    isMobile,
  }
}

export default useMenuLayout
